<app-gatekeeper *ngIf="!globals.isReset && globals.showGatekeeper"></app-gatekeeper>


<app-resetpass *ngIf="globals.isReset"></app-resetpass>
